import { global } from "../tools/global";
var EDynaduxDebugMiddlewareActions;
(function (EDynaduxDebugMiddlewareActions) {
    EDynaduxDebugMiddlewareActions["SET_STATE"] = "__EDynaduxDebugMiddlewareActions__SET_STATE";
})(EDynaduxDebugMiddlewareActions || (EDynaduxDebugMiddlewareActions = {}));
export const dynaduxDebugMiddleware = (config) => {
    const { debuggerStoreName = '', consoleDispatch = true, consolePayload = false, consoleState = false, consoleMethod = 'debug', consoleFilter = () => true, } = config;
    if (!debuggerStoreName)
        return {}; // Exit, it is disabled.
    let lastDispatch = 0;
    let dispatch;
    let activeIndex = 0;
    const dynaduxDebugger = global[debuggerStoreName] = {
        log: [],
        dispatch: (action, payload) => dispatch(action, payload),
        get list() {
            return dynaduxDebugger.log.map((log) => log.description).forEach(t => console.log(t));
        },
        get listPayloads() {
            return dynaduxDebugger.log.map((log) => [log.description, log.payload]).forEach(t => console.log(...t));
        },
        search: (text) => {
            const textLowerCase = text.toLowerCase();
            return dynaduxDebugger.log.filter((item) => item.description.toLowerCase().indexOf(textLowerCase) > -1);
        },
        set: (userDispatchIndex) => {
            if (userDispatchIndex === -1) {
                console.error('Nothing is dispatched yet');
                return;
            }
            const logItem = dynaduxDebugger.log[userDispatchIndex];
            if (!logItem) {
                console.error(`Item ${userDispatchIndex} cannot be found`);
                return;
            }
            dispatch(EDynaduxDebugMiddlewareActions.SET_STATE, logItem.after);
        },
        prev: () => {
            activeIndex--;
            if (activeIndex < 0)
                activeIndex = 0;
            dynaduxDebugger.set(activeIndex);
        },
        next: () => {
            activeIndex++;
            if (activeIndex + 1 > dynaduxDebugger.log.length)
                activeIndex = dynaduxDebugger.log.length - 1;
            dynaduxDebugger.set(activeIndex);
        },
        now: () => {
            activeIndex = dynaduxDebugger.log.length - 1;
            dynaduxDebugger.set(activeIndex);
        },
        get state() {
            return dynaduxDebugger.log[activeIndex].after;
        },
    };
    const middleware = {
        init: (store) => {
            dispatch = store.dispatch;
            // @ts-ignore
            middleware.after({
                action: 'INFO DynaduxDebugMiddleware Initial State',
                initialState: {},
                state: store.state,
                payload: {
                    debugInfo: 'This is not a real dispatch, it is a log info of DynaduxDebugMiddleware.',
                    debugTag: 2487602415245,
                },
                dispatch: store.dispatch,
            });
        },
        before: ({ action }) => {
            if (action === EDynaduxDebugMiddlewareActions.SET_STATE)
                return;
            // If the developer travels in past, return him now
            if (activeIndex + 1 < dynaduxDebugger.log.length) {
                activeIndex = dynaduxDebugger.log.length - 1;
                return dynaduxDebugger.log[activeIndex].after;
            }
        },
        after: ({ action, payload, initialState, state, reducerElapsedMs, changed, }) => {
            if (action === EDynaduxDebugMiddlewareActions.SET_STATE)
                return payload;
            const now = new Date();
            const nextIndex = dynaduxDebugger.log.length;
            activeIndex = nextIndex;
            const afterMs = (() => {
                if (lastDispatch === 0)
                    return undefined;
                return now.valueOf() - lastDispatch;
            })();
            const logItem = {
                description: [
                    frontSpace(' ', `#${nextIndex}`, 5),
                    frontSpace(' ', `+${duration(afterMs)}`, 10),
                    frontSpace(' ', duration(reducerElapsedMs), 6),
                    frontSpace(' ', `${now.toLocaleTimeString()}.${frontSpace('0', now.getMilliseconds(), 4)}`, 13),
                    action,
                ].join(' '),
                action,
                afterMs,
                payload,
                before: initialState,
                after: state,
                date: now,
                changed,
            };
            dynaduxDebugger.log.push(logItem);
            lastDispatch = now.valueOf();
            if (consoleDispatch
                && (!payload || payload.debugTag !== 2487602415245)
                && consoleFilter(action, payload)) {
                // eslint-disable-next-line no-console
                console[consoleMethod](...([
                    [
                        debuggerStoreName,
                        frontSpace(' ', `#${nextIndex}`, 5),
                        frontSpace(' ', `+${duration(afterMs)}`, 10),
                        frontSpace(' ', duration(reducerElapsedMs), 6),
                        frontSpace(' ', `${now.toLocaleTimeString()}.${frontSpace('0', now.getMilliseconds(), 4)}`, 13),
                        action,
                    ].filter(Boolean).join(' '),
                    consolePayload && { Payload: payload },
                    consoleState && {
                        before: initialState,
                        after: state,
                        changed,
                    },
                ].filter(Boolean)));
            }
        },
    };
    return middleware;
};
const frontSpace = (spacer, content, length) => {
    const text = String(content);
    if (text.length >= length)
        return text;
    return `${Array(length).fill(spacer)
        .join('')}${text}`.substring(-length);
};
const duration = (d = 0) => {
    if (d > 10000)
        return (d / 1000).toFixed(2) + 'sec';
    return d + 'ms';
};
